import { connector } from "../../utils/common/connector";

const controller = "deposit";

// ---------------------------------------------
// GET DEPOSIT TYPES BY COMPANY
// ---------------------------------------------
export const getDepositTypesService = async (params) => {
  let reply;

  try {
    const response = await connector.get(
      controller,
      "getDepositsByCompany",
      params,
    );

    reply = {
      deposits: response?.deposits ?? [],
    };
  } catch (error) {
    console.log(error);
    reply = {
      deposits: [],
    };
  }

  return reply;
};

// ---------------------------------------------
// GET ALL DEPOSITS BY COMPANY
// ---------------------------------------------
export const getAllDepositsByCompanyService = async (params) => {
  let reply;

  try {
    const response = await connector.get(
      controller,
      "getAllDepositsByCompany",
      params,
    );

    reply = {
      deposits: response?.deposits ?? [],
    };
  } catch (error) {
    console.log(error);
    reply = {
      deposits: [],
    };
  }

  return reply;
};

// ---------------------------------------------
// GET DEPOSITS BY PAGINATION
// ---------------------------------------------
export const getDepositsByPaginationService = async (params) => {
  let reply;

  try {
    const response = await connector.get(
      controller,
      "getDepositsByPagination",
      params,
    );

    reply = {
      deposits: response?.deposits ?? [],
      totalRecords: response?.totalRecords ?? 0,
    };
  } catch (error) {
    console.log(error);
    reply = {
      deposits: [],
      totalRecords: 0,
    };
  }

  return reply;
};

// ---------------------------------------------
// CREATE DEPOSIT TYPE
// ---------------------------------------------
export const createDepositTypeService = async (params) => {
  let reply;

  try {
    const response = await connector.post(controller, "newDepositType", params);

    reply = response ?? { success: false };
  } catch (error) {
    console.log(error);
    reply = { success: false };
  }

  return reply;
};

// ---------------------------------------------
// UPDATE DEPOSIT TYPE
// ---------------------------------------------
export const updateDepositTypeService = async (params) => {
  let reply;

  try {
    const response = await connector.post(
      controller,
      "updateDepositType",
      params,
    );

    reply = response ?? { success: false };
  } catch (error) {
    console.log(error);
    reply = { success: false };
  }

  return reply;
};
